<p-toast
  position="bottom-right"
  [baseZIndex]="7000"
  [key]="key"
  [showTransitionOptions]="showTransitionOptions"
  [hideTransitionOptions]="hideTransitionOptions">
  <ng-template let-message pTemplate="headless" let-closeFn="closeFn">
    <div class="relative flex flex-col">
      <div class="p-toast-header">
        <div class="p-toast-title">
          <i *ngIf="getIcon(message.severity) as icon" [ngClass]="icon" class="p-message-icon"></i>
          <h3>
            <ng-container
              [ngTemplateOutlet]="message.summary ? toastSummaryTitle : toastSeverityTitle"
              [ngTemplateOutletContext]="{ message }">
            </ng-container>
          </h3>
        </div>
        <div>
          <button
            pButton
            class="p-button-text p-button-icon-only p-button-round p-button-sm overflow-visible"
            (click)="closeFn($event)"
            icon="fa-regular fa-times"></button>
        </div>
      </div>
      <div class="p-toast-content">
        <span [innerHTML]="message.detail | safe: 'html'"></span>
      </div>
      <div
        class="p-toast-progress"
        [style.animation-duration]="message.life + 'ms'"
        *ngIf="message.life > 0 && !message.sticky"></div>
    </div>
  </ng-template>
</p-toast>

<ng-template #toastSummaryTitle let-message="message">
  {{ message.summary }}
</ng-template>

<ng-template #toastSeverityTitle let-message="message">
  <ng-container [ngSwitch]="message.severity">
    <ng-container *ngSwitchCase="'error'">{{ 'common.error' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'warn'">{{ 'common.warning' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'success'">{{ 'common.success' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'info'">{{ 'common.info' | translate }}</ng-container>
  </ng-container>
</ng-template>
